<template>
  <div>
    <template v-if="loading_email === true">
      <loading />
    </template>
    <template v-else>
      <div class="col s12 m12 no-padding contact-section">
        <div class="col s12 no-padding title-buttons-wrapper">
          <div class="col s6">
            <h6>
              Email
              <i v-if="emails.length > 0" class="material-icons">check</i>
              <template v-else>
                <i v-if="meta.censo_domain[selectedMunicipio].formulario_documentos_obrigatorios.contatos.includes('emails')" class="material-icons red-text">error</i>
              </template>
            </h6>
          </div>
          <div class="col s6">
            <a v-if="form_email === false" @click="addNewEmail" class="waves-effect waves-light btn right">Adicionar email</a>
            <a v-else @click="addNewEmail" class="waves-effect waves-light btn red right">Cancelar</a>
          </div>
        </div>
        <div v-if="form_email === false" class="col s12 no-padding lista-email-wrapper">
          <template v-for="(email, i) in emails">
            <div class="col s12 m6 l4" v-bind:key="i">
              <div class="card">
                <div class="card-content">
                  <div class="col s12">
                    <p>
                      <i class="material-icons">email</i>
                      <span>{{ email['email'] }}</span>
                    </p>
                  </div>
                </div>
                <div class="card-action">
                    <div class="col s12 censo">
                      <a @click="removeEmail(email['email_id'])" title="Remover email" class="red-text action-delete">
                        <i class="material-icons">delete</i>
                      </a>
                    </div>
                  </div>
              </div>
            </div>
          </template>
        </div>
        <template v-else>
          <div class="col s12 no-padding form-email-wrapper">
            <div class="input-field col s12 m6">
              <input v-model="new_email.email" id="email" type="email" v-bind:class="{'invalid': error_fields['email']}">
              <label for="email">Email</label>
              <span class="helper-text" data-error="Este campo deve ser preenchido"></span>
            </div>
            <div class="input-field col s12 m6">
              <select v-model="new_email.email_class" id="email_class" v-bind:class="{'invalid': error_fields['email_class']}">
                <option value="" selected>Selecione</option>
                <option value="I">Institucional</option>
                <option value="P">Particular</option>
              </select>
              <label for="email_class">Classificação do email</label>
              <span class="helper-text" data-error="Este campo deve ser preenchido"></span>
            </div>
          </div>
          <div class="col s12 m12">
            <a @click="prepareSubmitTelefone" v-bind:disabled="verificaForm === false" class="waves-effect waves-light btn right">Salvar</a>
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import Loading from '@/components/Loading.vue'
import axios from 'axios'
import {CONFIG} from '@/config/config.js'
import SocialService from '@/services/social-service.js'

let socialService = new SocialService(CONFIG.URL_SOCIAL_API_V2)

export default {
  name: 'Emails',
  components: {
    loading: Loading
  },
  props: {
    emails_data: Array,
    pf_id: String
  },
  data (){
    return {
      meta: this.$store.state.meta.data,
      form_email: false,
      loading_email: false,
      emails: this.emails_data,
      new_email: {
        email: null,
        email_class: null
      },
      error_fields: {},
      selectedMunicipio: localStorage.selectedMunicipio
    }
  },
  computed: {
    verificaForm: function() {
      return this.new_email.email != null && this.new_email.email_class != null
    }
  },
  methods: {
    getEmails(){
      axios.get(`${CONFIG.URL_SOCIAL_API_V2}/v1/pessoa-fisica/emails/${this.pf_id}/`)
      .then((response) => {
        this.emails = []
        response.data.data.SocialAPI.current.forEach((email) => {
          this.emails.push({
            email_id: email['email_id'],
            email: email['email_email'],
            email_class: email['email_class'],
          })
        })
      })
      .catch((error) => {

      })
      .finally(() => {
        this.loading_email = false
        setTimeout(() => {
          this.form_email = false
        }, 100)
      })
    },
    async submitInsertEmail(email){
      axios.post(`${CONFIG.URL_SOCIAL_API_V2}/v1/pessoa-fisica/emails/`, {
        ...email,
        ...{
          'pf_id': this.pf_id,
          'device': await socialService.getDeviceInfo()
        }
      })
      .then((response) => {
        this.getEmails()
      })
      .catch((error) => {
        M.toast({html: 'Não foi possível realizar esta operação...verifique a sua conexão com a internet e tente novamente!'})
        this.loading_email = false
        this.form_email = false
      })
    },

    prepareSubmitTelefone(){
      this.loading_email = true
      return this.submitInsertEmail(this.new_email)
    },
    addNewEmail() {
      this.form_email = !this.form_email
      if (this.form_email === true) {
        this.loadFields()
        this.new_email = {
          email: null,
          email_class: null
        }
      }
    },
    async removeEmail(email_id){
      this.loading_email = true
      axios({
        method: "DELETE",
        url: `${CONFIG.URL_SOCIAL_API_V2}/v1/pessoa-fisica/emails/${this.pf_id}/${email_id}/`, 
        data: {
          device: await socialService.getDeviceInfo()
        }
      })
      .then((response) => {
        this.emails.forEach((item, i) => {
          if(item['email_id'] === email_id){
            this.emails.splice(i, 1)
          }
        })
        this.loading_email = false
        setTimeout(() => {
          this.initFields()
        }, 100)
      })
      .catch((error) => {
        M.toast({html: 'Não foi possível realizar esta operação...verifique a sua conexão com a internet e tente novamente!'})
        this.loading_email = false
        setTimeout(() => {
          this.initFields()
        }, 100)
      })
    },
    verificaStatusPasso(){
      let keys = ['email']
      let selectKeys = ['email_class']

      let status = true //Até que se prove o contrário
      keys.forEach((key) => {
        if(this.new_email[key] == null || this.new_email[key] == ''){
          status = false
          this.$set(this.error_fields, key, true)
        } else {
          this.$set(this.error_fields, key, false)
        }
      })

      selectKeys.forEach((sKey) => {
        try{
          if(this.new_email[sKey] == null || this.new_email[sKey] == ''){
            status = false
            M.FormSelect.getInstance(document.getElementById(sKey)).wrapper.classList.add('invalid')
            this.$set(this.error_fields, sKey, false)
          } else {
            M.FormSelect.getInstance(document.getElementById(sKey)).wrapper.classList.remove('invalid')
            this.$set(this.error_fields, sKey, true)
          }
        } catch(e) {
          status = false
        }
      })
      return status
    },
    loadFields() {
      setTimeout(() => {
        M.updateTextFields()
        M.FormSelect.init(document.querySelectorAll('select'))
        M.Tooltip.init(document.querySelectorAll('.tooltipped'))
      }, 200)
    },
  },
  watch: {
    new_email: {
      handler: function(updated, old){
        this.changed = true
        setTimeout(() => {
          this.verificaStatusPasso()
        }, 100)
      },
      deep: true
    }
  },

  mounted(){
    setTimeout(() => {
      this.verificaStatusPasso()
    }, 500)
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/steps/contatos/Emails.vue